<template>
  <PageLoader v-if="isloading" />
  <HeadWithLogo/>
  <h4 class="pt-4">ثبت نام نهایی</h4>
  <br/>
  <span class="sp-danger">نمره آزمون شما: {{ score }}</span>
  <div class="row mt-3 txt-bold">
    <div class="col-12 col-md-6">
      <h6>نام و نام خانوادگی:{{ fullname }}</h6>
    </div>
    <div class="col-12 col-md-6">
      <h6>شماره تماس: {{ phone }}</h6>
    </div>
  </div>
  <Form @submit="onSubmit">
    <div class="row mt-3 txt-bold">
      <div class="col-12 col-md-6">
        <label for="FatherName" class="form-label pt-4 pt-md-0"><label class="star">*</label>نام پدر</label>
        <Field type="text" class="form-control" v-model="father" name="FatherName" :rules="isRequired"/>
        <ErrorMessage name="FatherName"/>
      </div>
      <div class="col-12 col-md-6 cu-input">
        <label for="faith" class="form-label"><label class="star">*</label>دین</label>
        <Field as="select" name="faith" v-model="din" class="form-select" :rules="isRequired">
          <option value="اسلام" :value="اسلام">اسلام</option>
        </Field>
        <ErrorMessage name="faith"/>
      </div>
      <div class="col-12 col-md-6 cu-input pt-4">
        <label for="religion" class="form-label"><label class="star">*</label>مذهب</label>
        <Field as="select" name="religion" v-model="mazhab" class="form-select" :rules="isRequired">
          <option value=""></option>
          <option value="شیعه">شیعه</option>
          <option value="اهل سنت">اهل سنت</option>
        </Field>
        <ErrorMessage name="religion"/>
      </div>
      <div class="col-12 col-md-6 cu-input pt-4">
        <label for="education" class="form-label"><label class="star">*</label>تحصیلات</label>
        <Field as="select" name="education" v-model="edu" class="form-select" :rules="selector">
          <option value=""></option>
          <option value="بی سواد">بی سواد</option>
          <option value="ابتدایی">ابتدایی</option>
          <option value="سیکل">سیکل</option>
          <option value="دیپلم">دیپلم</option>
          <option value="فوق دیپلم">فوق دیپلم</option>
          <option value="لیسانس">لیسانس</option>
          <option value="فوق لیسانس">فوق لیسانس</option>
          <option value="دکترا">دکترا</option>
          <option value="حوزوی سطح 1">حوزوی سطح 1</option>
          <option value="حوزوی سطح 2">حوزوی سطح 2</option>
          <option value="حوزوی سطح 3">حوزوی سطح 3</option>
          <option value="حوزوی سطح 4">حوزوی سطح 4</option>
        </Field>
        <ErrorMessage name="education"/>
      </div>
      <div class="col-12 col-md-6 pt-4">
        <label for="field" class="form-label"><label class="star">*</label>رشته</label>
        <Field type="text" class="form-control" v-model="reshte" name="field" :rules="isRequired"/>
        <ErrorMessage name="field"/>
      </div>
      <div class="col-12 pt-4">
        <label><label class="star">*</label>آدرس</label>
        <Field as="textarea" class="form-control" style="height: 100px;" v-model="address" name="address" :rules="isRequired"></Field>
        <ErrorMessage name="address"/>
      </div>
      <div class="col-12 pt-4">
        <p>
          در زمان بارگذاری تصاویر حجم تصویر را پایین بیاورید و در صورتی که در بارگذاری به مشکل خوردید مدارک
          را در ایتا به شماره
          ارسال کنید.
        </p>
      </div>
      <div class="col-12 pt-4">
        <h6><label class="star"></label>تصویر کارت ملی یا صفحه اول شناسنامه</h6>
        <div class="mb-3">
          <label for="formFile" class="form-label"></label>
          <input class="form-control" @change="handleFileUploadNational( $event )" type="file"
                 id="formFileNational">
        </div>
      </div>
      <div class="col-12 pt-4">
        <div class="mb-3">
          <label for="formFile" class="form-label">مدرک شناسایی از بسیج یا حوزه علمیه یا موسسه فرهنگی</label>
          <input class="form-control" @change="handleFileUploadDocument1( $event )" type="file"
                 id="formFileDocument1">
        </div>
      </div>
    </div>
  </Form>
  <br/>
  <div class="text-center mt-3">
    <span class="sp-danger"> در صورت وجود سوال یا اشکال، در پیام رسان واتساپ، ایتا و بله به شماره 09960936122 پیام دهید. </span>
  </div>
  <div class="row my-3">
    <div class="col-6 text-end">
      <RouterLink to="/final-exam-rule" class="btn btn-success px-3">
        صفحه قبل
      </RouterLink>
    </div>
    <div class="col-6 text-start">
      <button @click="handleSubmitFinalForm" class="btn btn-success submit-btn">ثبت</button>
    </div>
  </div>
  <div class="text-center my-2 mt-3" v-for="error in errorMessage">
    <span class="text-danger mx-auto" ><b> {{ error[0] }}</b></span>
  </div>
  <div class="text-danger mx-auto mt-3" ><b>{{ errorMessage2 }}</b></div>
</template>
<style scoped>

</style>
<script>
import {Form, Field, ErrorMessage} from 'vee-validate';
import axios from 'axios';
import router from '@/router';
import PageLoader from '../components/Loader'
import HeadWithLogo from "@/components/HeadWithLogo";
export default {
  data() {
    return {
      fullname: "",
      score: "",
      phone: "",
      father: "",
      din: "",
      selected: "اسلام",
      mazhab: "",
      edu: "",
      reshte: "",
      state: "",
      city: "",
      address: "",
      accepting_rules: 1,
      national_file: "",
      document1_file: "",
      document2_file: "",
      errorMessage: "",
      errorMessage2: "",
      isloading: false,
      states:"",
      cities:""
    }
  }, components: {
    HeadWithLogo,
    Form,
    Field,
    ErrorMessage,
    PageLoader
  },
  mounted() {
    if (localStorage.name) {
      this.fullname = localStorage.name
    }
    if (localStorage.score) {
      this.score = localStorage.score
    }
    if (localStorage.phone) {
      this.phone = localStorage.phone
    }
    if (!localStorage.token) {
      router.push('/PhoneNumber')
    }
     axios
      .get(process.env.VUE_APP_ROOT_API+'/api/getStates?api=sfFSadAs1432')
      .then(response => (this.states = response.data))
  },
  methods: {
    isRequired(value) {
      if (value && value.trim()) {
        return true;
      }
      return 'پر کردن فیلد الزامی است';
    }, selector(value) {
      if (value) {
        return true;
      }
      return 'انتخاب مورد الزامی است';
    },
    handleFileUploadNational(event) {
      this.national_file = event.target.files[0];
    },
    handleFileUploadDocument1(event) {
      this.document1_file = event.target.files[0];
    },
    handleFileUploadDocument2(event) {
      this.document2_file = event.target.files[0];
    },
    handleSubmitFinalForm() {
      this.errorMessage=""
      this.errorMessage2=""
      this.isloading=true;
      let formData = new FormData();
      formData.append('national', this.national_file);
      formData.append('document1', this.document1_file);
      // formData.append('document2', this.document2_file);

      const headers = {
        accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        Authorization: 'Bearer ' + localStorage.token,
      }
      axios.get(process.env.VUE_APP_ROOT_API+"/sanctum/csrf-cookie").then(() => {
        axios
            .post(process.env.VUE_APP_ROOT_API+'/api/step5?father=' + this.father + '&din=' + this.din + '&mazhab=' + this.mazhab + '&edu=' + this.edu + '&reshte=' + this.reshte + '&state=' + this.state + '&city=' + this.city + '&address=' + this.address + '&second_affiliate_fullname=' + this.second_affiliate_fullname + '&second_affiliate_phone_number=' + this.second_affiliate_phone + '&second_affiliate_job=' + this.second_affiliate_job + '&accepting_rules=' + this.accepting_rules, formData, {
              headers: headers
            })
            .then(response => {
              this.isloading=false
              this.messages = response.data
              if (this.messages.status == "done") {
                alert(this.messages.message)
                router.push("/final")

              } else {
                //alert(this.messages.message)
                this.errorMessage2=this.messages.message
              }
              // router.push("/final")
            })
            .catch((err) => {
              this.isloading=false
              this.errorMessage = err.response.data.errors
            })
      })
    },
    handleChangeState(){
      axios
        .get(process.env.VUE_APP_ROOT_API+'/api/getCities?api=sfFSadAs1432&state_id='+this.state)
        .then(response => (this.cities = response.data))
    }
  }
}
</script>